import React from 'react'
import BeautifulMessage from './2Molecules/BeautifulMessage';
import { Button, Col, Modal, Row, Spinner,FormControl } from 'react-bootstrap';
import firebase from 'gatsby-plugin-firebase'

const Signup = () => {
    const [fullName, setFullName ] = React.useState('')
    const [email, setEmail ] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [loader, showLoader] = React.useState('none')

    React.useEffect(() => {
        localStorage.setItem("AppUser", JSON.stringify({
            membershipId : "",
            isActive :false,
            email : "",
            displayName : "",
            photoURL :'https://i.ibb.co/LzX5R1k/profile.png',
            uid : "null"
        }))
    },[])
    const handleSignup = () => {
        if(email =='' || password == '' || fullName =='') {
            window.alert("PLease Enter Valid Information")
            return
        }

        showLoader('block')
        firebase.auth()
        .createUserWithEmailAndPassword(email, password)
        .then(result => {
            result.user.updateProfile({
                displayName: fullName,
                photoURL : 'https://i.ibb.co/LzX5R1k/profile.png'
              })
              .then(()=>{
                const  user = firebase.auth().currentUser
                const appUser = {
                    membershipId : "",
                    isActive :false,
                    email : email,
                    displayName : fullName,
                    photoURL :'https://i.ibb.co/LzX5R1k/profile.png',
                    uid : user.uid
                }
                localStorage.setItem("AppUser", JSON.stringify(appUser))
                window.location.reload();
            })
        })
        .catch(err => {
            showLoader('none')
            window.alert("ERR " + err)
        })
}
return(
<>
    <div>
        <h2>SIGNUP</h2>
        <FormControl className="mb-3"
                placeholder="Enter Full Name"
                aria-label="Email"
                aria-describedby="basic-addon2"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
        />
        <FormControl className="mb-3"
                placeholder="Enter Email"
                aria-label="Email"
                aria-describedby="basic-addon2"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
        />
        <FormControl className="mb-3"
                placeholder="Enter Password"
                aria-label="Password"
                aria-describedby="basic-addon1"
                value={password}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
        />
        <Button className="mb-3" variant="primary" onClick={() => handleSignup()} >
            SIGNUP
        </Button>
    </div>
    <div style={{
        backgroundColor: '#000',
        opacity : 0.4,
        zIndex : 999,
        justifyContent : 'center',
        flexDirection : 'column',
        alignItems :"center",
        position: 'absolute',
        display : loader,
        paddingTop : 75,
        top:0,bottom:0,left:0,right:0
    }}>
        <Spinner animation="border" variant="success" />
    </div>

</>
)
}

export default Signup